/**
 * Global ban state — a tiny store so ANY code (React or the axios interceptors)
 * can flip the app into the "your account is suspended" screen. A single check
 * in AppShell renders <BannedPage/> whenever this is set, overriding the normal
 * authed app. Set by the shared ban interceptor when the backend returns
 * 403 { error: 'user_banned' } from get-user-id (login/signup) or any API call.
 */
import { create } from 'zustand';

interface BanState {
  isBanned: boolean;
  reason?: string;
  setBanned: (reason?: string) => void;
  clearBanned: () => void;
}

export const useBanStore = create<BanState>((set) => ({
  isBanned: false,
  reason: undefined,
  setBanned: (reason) => set({ isBanned: true, reason }),
  clearBanned: () => set({ isBanned: false, reason: undefined }),
}));
